import { render, staticRenderFns } from "./App.vue?vue&type=template&id=acb3dec4"
import script from "./app.ts?vue&type=script&lang=ts&external"
export * from "./app.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('acb3dec4')) {
      api.createRecord('acb3dec4', component.options)
    } else {
      api.reload('acb3dec4', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=acb3dec4", function () {
      api.rerender('acb3dec4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/App.vue"
export default component.exports